export { Login } from "./Login";
export { default as Registro } from "./Register";
export { default as Profile } from "./Profile";
export {default as ResetPassword} from "./ResetPassword";
export {default as VerifyPassword} from "./VerifyPassword";